import * as ERRORES from "../../config/constants/step-constants";

export const GoogleRMKT = {
  enable() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//www.googleadservices.com/pagead/conversion_async.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.google_trackConversion;
  },
  init() {},
  _enviarRMKT() {
    window.google_trackConversion({
      google_conversion_id: 685925423,
      google_custom_params: window.google_tag_params,
      google_remarketing_only: true
    });
  },
  paso1() {
    window.google_tag_params = {
      Pasos: "Paso 1",
      Categoría: "1",
      Producto: "Emprendedores"
    };
    GoogleRMKT._enviarRMKT();
  },
  paso2() {
    window.google_tag_params = {
      Pasos: "Paso 2",
      Categoría: "2",
      Producto: "Emprendedores"
    };
    GoogleRMKT._enviarRMKT();
  },
  paso3() {
    window.google_tag_params = {
      Pasos: "Paso 3",
      Categoría: "3",
      Producto: "Emprendedores"
    };
    GoogleRMKT._enviarRMKT();
  },
  paso4() {
    window.google_tag_params = {
      Pasos: "Paso 4",
      Categoría: "4",
      Producto: "Emprendedores"
    };
    GoogleRMKT._enviarRMKT();
  },
  gracias() {
    window.google_tag_params = {
      Pasos: "FormularioEnviado",
      Categoría: "Thank You",
      Producto: "Emprendedores"
    };
    GoogleRMKT._enviarRMKT();
  },
  mensaje(context) {
    switch (context.mutation.payload.params.mje) {
      case ERRORES.ERROR_TECNICO:
        window.google_tag_params = {
          Pasos: "Error",
          Categoría: "Error",
          Producto: "Emprendedores"
        };
        GoogleRMKT._enviarRMKT();
        break;
      case ERRORES.INDIVIDUO_NEGATIVO:
        window.google_tag_params = {
          Pasos: "Ya Registrado",
          Categoría: "Ya Registrado",
          Producto: "Emprendedores"
        };
        GoogleRMKT._enviarRMKT();
        break;
    }
  }
};

export const GoogleSiteTag = {
  enable() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = function() {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-685925423";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },
  landing() {
    window.gtag("js", new Date());
    window.gtag("config", "AW-685925423");
  },
  paso1() {
    window.gtag("event", "conversion", {
      send_to: "AW-685925423/MM8dCJrHveYBEK_IiccC"
    });
  },
  paso2() {
    window.gtag("event", "conversion", {
      send_to: "AW-685925423/PKw8COnOveYBEK_IiccC"
    });
  },
  paso3() {
    window.gtag("event", "conversion", {
      send_to: "AW-685925423/RR5GCO3PveYBEK_IiccC"
    });
  },
  paso4() {
    window.gtag("event", "conversion", {
      send_to: "AW-685925423/yENqCK7z2eYBEK_IiccC"
    });
  },
  gracias() {
    window.gtag("event", "conversion", {
      send_to: "AW-685925423/SdwlCNnQveYBEK_IiccC"
    });
  },
  mensaje(context) {
    switch (context.mutation.payload.params.mje) {
      case ERRORES.ERROR_TECNICO:
        window.gtag("event", "conversion", {
          send_to: "AW-685925423/sK9uCM2w2uYBEK_IiccC"
        });
        break;
      case ERRORES.INDIVIDUO_NEGATIVO:
        window.gtag("event", "conversion", {
          send_to: "AW-685925423/7ZC9CICQvuYBEK_IiccC"
        });
        break;
    }
  }
};
